import React, {useContext, useEffect, useRef} from "react";


import {
    BackButton,
    Button,
    FlexRowSpaceBetween,

} from "../../../../common/components/libs";

import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import { useHistory, useParams } from "react-router-dom";

import { FadeInOutVertical } from "../../../../common/components/Animated";
import { SnackbarType } from "../../../../stores/common";

import EditDeliveryConditions from "./components/EditDeliveryConditions";
import UpdateChatForm from "./components/UpdateChatForm";
import Grid from "@material-ui/core/Grid";
import GeneralInfoBlock from "./blocks/GeneralInfoBlock";
import OrderSettingsPageStoreContext from "./context";
import MenuUISettingsBlock from "./blocks/MenuUISettingsBlock";
import DeliveryTypesBlock from "./blocks/DeliveryTypesBlock";
import PaymentSettingsBlock from "./blocks/PaymentSettingsBlock";
import ChatsBlock from "./blocks/ChatsBlock";
import QRCodesBlock from "./blocks/QRCodesBlock";
import AliasesBlock from "./blocks/AliasesBlock";
import ContactInfoBlock from "./blocks/ContactInfoBlock";
import WorkingScheduleBlock from "./blocks/WorkingScheduleBlock";
import ChoosingLanguagesBlock from "./blocks/ChoosingLanguagesBlock"
import IIkoIntegrationMessage from "./blocks/IIkoIntegrationMessage";
import { Trans, useTranslation } from "react-i18next";
import EditTelegramNotifications from "./components/EditTelegramNotifications";
import { MenuType} from "../../../../services/menu/models";
import EditDeliveryZonesForm from "./components/EditDeliveryZones";
import TariffPromptForm from './components/TariffPromptForm';
import TariffWarningMessage from './blocks/TariffWarningMessage';


const OrdersSettingsPage = () => {
    const {t, ready} = useTranslation(["general", "menu"], { useSuspense: false });
    const { generalMenuStore, generalStore } = useStores();

    const params = useParams<{ menuId: string, menuType: MenuType }>();
    const menuId = parseInt(params.menuId);
    const history = useHistory();
    const store = useContext(OrderSettingsPageStoreContext);
    const menuType = store.menuType;

    const refToChat = useRef(null);
    const scrollToChat = () => refToChat.current?.scrollIntoView()

    useEffect(() => {
        (async () => {
            await generalMenuStore.fetchMenus(params.menuType);
            store.setMenu(generalMenuStore.getMenuById(menuId, params.menuType));
        })();
    }, [menuId, ready]);


    const handleSubmit = async () => {
        let res;
        if (store.current) {
            res = await generalMenuStore.updateMenu(store.current.id, store.getUpdatedData());
        } else {
            res = await generalMenuStore.createMenu(store.getUpdatedData());
        }
        if (res.err) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:orderSettingsPage.menuNotSaved"),
                type: SnackbarType.error
            });
        } else {
            generalStore.showSnackbar({
                title: t("menu:orderSettingsPage.menuSuccessfullyUpdated"),
                type: SnackbarType.success
            });
            history.goBack();
        }
    };

    if(!store.current) return;


    return (
        <FadeInOutVertical show={true}>
            <div style={{ maxWidth: 800 }}>
                <BackButton/>
                <TariffWarningMessage/>
                <IIkoIntegrationMessage/>
                <GeneralInfoBlock ref={refToChat} scroll={()=>{scrollToChat()}}/>
                <ChoosingLanguagesBlock/>
                <ContactInfoBlock/>
                <WorkingScheduleBlock/>
                <MenuUISettingsBlock/>
                {menuType === MenuType.regular && <DeliveryTypesBlock/>}
                <PaymentSettingsBlock/>
                <div ref={refToChat}><ChatsBlock /></div>
                <AliasesBlock/>
                {/*{menuType === MenuType.regular && <QRCodesBlock/> }*/}

                <FlexRowSpaceBetween style={{ marginTop: 20, width: "100%" }}>
                    <Grid container justify="flex-end">
                        <Button
                            color="secondary"
                            mr={5}
                            onClick={() => {
                                history.goBack()
                            }}
                        >
                            {t("general:back")}
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            {t("general:save")}
                        </Button>
                    </Grid>
                </FlexRowSpaceBetween>
                <EditDeliveryConditions/>
                <UpdateChatForm/>
                <TariffPromptForm/>
                <EditTelegramNotifications/>
                <EditDeliveryZonesForm/>
            </div>
        </FadeInOutVertical>
    )
};

export default observer(OrdersSettingsPage);
